import React, { FC } from 'react';
import UpgradeDialog from 'src/components/widgets/upgradeDialog/upgradeDialog';
import { useSubscriptionData } from 'src/shared/hooks/useSubscriptionData';
import styled from 'styled-components';

const Banner = styled(UpgradeDialog)`
    margin-bottom: 10px;
`;

// The drawer editors reuse the tool pages' upgrade banner, so hitting a plan limit looks the same
// wherever the seller runs into it. It is not dismissable: it is the only thing explaining why the
// editor is read-only.
export const PlanUpgradeBanner: FC<{ message: string }> = ({ message }) => {
    const { sellerMarketplace } = useSubscriptionData();

    return (
        <Banner
            type={'BANNER'}
            marketPlace={sellerMarketplace ?? undefined}
            redirectUrlFromDashboard={encodeURI(window.location.href)}
            showCloseButton={false}
            showUpgradeButtonAsLink={true}
            message={message}
        />
    );
};
